import React, { useEffect } from 'react';
import { Badge } from '..';

const verticalBorderClassName = 'radio-group-vertical border rounded-lg p-3';
const horizontalBorderClassName = 'radio-group-horizontal border rounded-lg py-2 px-6';

export const Radio = ({
  children,
  value,
  label,
  onSelect,
  selectedValue,
  vertical,
  className = '',
  isDisabled,
  showIndicator,
  badge = null,
  tooltip,
}: any) => {
  return (
    <label
      className={`${className} relative grow md:basis-0 cursor-pointer flex items-center gap-2
        ${isDisabled ? 'pointer-events-none opacity-50' : ''}
        ${vertical ? verticalBorderClassName : horizontalBorderClassName}
        ${selectedValue === value ? 'border-red-500 is-active' : 'border-divider'}
      `}
    >
      <input
        type="radio"
        value={value}
        checked={selectedValue === value}
        onChange={onSelect}
        disabled={isDisabled}
        className="hidden peer"
      />
      {showIndicator && (
        <div className="w-4 h-4 border-2 border-gray-400 peer-checked:border-primary-500 peer-checked:border-4 rounded-full flex items-center justify-center absolute top-3 right-3 z-10">
          <div className="w-2 h-2 bg-transparent peer-checked:bg-primary-500 rounded-full"></div>
        </div>
      )}

      <div className="flex w-full h-full gap-2">
        {children || <div className="cursor-default">{label}</div>}
        {badge && <Badge variant='warning'>{badge}</Badge>}
        {tooltip ? <div className="-ml-1">{tooltip}</div> : undefined}
      </div>
    </label>
  );
};

export const RadioGroup = ({
  children,
  onChange,
  value,
  vertical = false,
  isDisabled = false,
  showIndicator = true,
}: any) => {
  const [selectedValue, setSelectedValue] = React.useState(value);

  const onSelect = (evt: any) => {
    const value = evt.target.value;
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  const childrenWithProps = React.Children.map(children, (child) =>
    child && React.cloneElement(child, { onSelect, selectedValue, vertical, isDisabled, showIndicator })
  );

  useEffect(() => {
    if (value !== selectedValue) {
      setSelectedValue(value);
    }
  }, [value]);

  return <div className={`flex text-sm cursor-pointer gap-3 ${vertical ? 'flex-col' : 'flex-col md:flex-row'}`}>{childrenWithProps}</div>;
};
